module.exports = __webpack_public_path__ + "media/Video 10.4d2601e0.mp4";